import { isSpectraData1D } from './isSpectraData1D';
export function formatData(input = []) {
    const inputClone = JSON.parse(JSON.stringify(input));
    const spectra = [];
    for (const spectraData of inputClone) {
        const { id, info } = spectraData;
        if (isSpectraData1D(spectraData)) {
            const ranges = rescaleIntegration({
                id,
                info,
                ranges: spectraData.ranges,
            });
            spectra.push({ id, info, ranges: { values: ranges } });
        }
        else {
            spectra.push({ id, info, zones: { values: spectraData.zones } });
        }
    }
    return spectra;
}
function rescaleIntegration(spectrum) {
    if (spectrum.info.nucleus !== '1H')
        return spectrum.ranges;
    const totalIntegration = spectrum.ranges.reduce((total, range) => (range.integration ? total + range.integration : total), 0);
    for (const range of spectrum.ranges) {
        if (range.integration) {
            range.integration *= 100 / totalIntegration;
            if (range.signals) {
                const totalSignalIntegration = range.signals.reduce((total, signal) => signal.integration ? total + signal.integration : total, 0);
                for (const signal of range.signals) {
                    if (signal.integration) {
                        signal.integration *= range.integration / totalSignalIntegration;
                    }
                    else {
                        signal.integration = range.integration;
                    }
                }
            }
        }
    }
    return spectrum.ranges;
}
//# sourceMappingURL=formatData.js.map